<template>
  <div class="flex items-center gap-2.5 flex-none">
    <button
      type="button"
      class="w-8 h-8 rounded-lg border border-surface-200 bg-white flex items-center justify-center text-base font-medium select-none"
      :class="canIncrement && !disabled ? 'text-surface-700 cursor-pointer' : 'text-surface-300 cursor-default'"
      @click="canIncrement && !disabled && $emit('update:modelValue', modelValue + step)"
    >+</button>
    <div class="min-w-[2.5rem] text-center text-sm font-semibold">
      {{ modelValue }}
      <span v-if="suffix" class="text-[11px] font-normal text-surface-500">{{ suffix }}</span>
    </div>
    <button
      type="button"
      class="w-8 h-8 rounded-lg border border-surface-200 bg-white flex items-center justify-center text-base font-medium select-none"
      :class="canDecrement && !disabled ? 'text-surface-700 cursor-pointer' : 'text-surface-300 cursor-default'"
      @click="canDecrement && !disabled && $emit('update:modelValue', modelValue - step)"
    >−</button>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(defineProps<{
  modelValue: number;
  min?: number;
  max?: number;
  step?: number;
  suffix?: string;
  disabled?: boolean;
}>(), { min: 1, max: 99, step: 1 });
defineEmits<{ 'update:modelValue': [value: number] }>();

const canIncrement = computed(() => props.modelValue < props.max);
const canDecrement = computed(() => props.modelValue > props.min);
</script>
